<div id="row" fxLayout="row" style="width: 100%;">
    <div id="container" fxFlex="100">
        <mat-card fxFlex="100" class="mt-10">
            <mat-card-title>
                <span class="p-10">#{{question.position}} {{question.questionName}}</span>
            </mat-card-title>
            <mat-card-subtitle>
                <span class="p-10">
                    <p *ngIf="question.answerType.options"> Intrebare cu <b>{{question.answerType.options.length}}</b> variante de raspuns </p>
                    <p *ngIf="!question.answerType.options"> Intrebare care necesita exprimare libera </p>
                </span>
            </mat-card-subtitle>
            <mat-card-content>
                <div fxFlex="100" class="p-24" style="max-width: 100%!important;">

                    <form [formGroup]="questionForm" >

                        <div fxLayout fxLayoutWrap fxLayoutGap="25px">

                            <mat-form-field appearance="standard" fxFlex="100" class="pr-4" *ngIf="question.answerType.options === null">
                                <mat-label>{{ question.answer.value }}</mat-label>
                                <input matInput formControlName="value" [value]="question.answer.value">
                                <mat-icon matSuffix>keyboard</mat-icon>
                            </mat-form-field>

                            <div style="width: 100%;" style="text-align: center;">
                                <mat-radio-group class="radio-group" formControlName="value">
                                    <mat-radio-button class="radio-button" *ngFor="let value of question.answer.values"
                                                      [value]="value.text"
                                                      [checked]="question.answer.value === value.text">{{value.text}}</mat-radio-button>
                                </mat-radio-group> 
                            </div>

                        </div>
                    </form>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

